import abdulrahman from 'assets/mentors/abdulrahman.jpg';
import adar from 'assets/mentors/adar.jpg';
import alec from 'assets/mentors/alec.jpg';
import amber from 'assets/mentors/amber.jpg';
import andrew from 'assets/mentors/andrew.jpg';
import ann from 'assets/mentors/ann.jpg';
import anurag from 'assets/mentors/anurag.jpg';
import apoorva from 'assets/mentors/apoorva.jpg';
import ashok from 'assets/mentors/ashok.jpg';
import brandon from 'assets/mentors/brandon.jpg';
import christian from 'assets/mentors/christian.jpg';
import clay from 'assets/mentors/clay.jpg';
import cody from 'assets/mentors/cody.jpg';
import corly from 'assets/mentors/corly.jpg';
import dave from 'assets/mentors/dave.jpg';
import david from 'assets/mentors/david.jpg';
import dustin from 'assets/mentors/dustin.jpg';
import edward from 'assets/mentors/edward.jpg';
import erik from 'assets/mentors/erik.jpg';
import frank from 'assets/mentors/frank.jpeg';
import gino from 'assets/mentors/gino.jpg';
import james from 'assets/mentors/james.jpg';
import james2 from 'assets/mentors/james2.jpg';
import jason from 'assets/mentors/jason.jpg';
import jeff from 'assets/mentors/jeff.jpg';
import john from 'assets/mentors/john.jpg';
import johnmark from 'assets/mentors/johnmark.jpg';
import jon from 'assets/mentors/jon.jpg';
import jonathan from 'assets/mentors/jonathan.jpg';
import jonathan2 from 'assets/mentors/jonathan2.png';
import joshua from 'assets/mentors/joshua.jpg';
import justin from 'assets/mentors/justin.jpeg';
import katharine from 'assets/mentors/katharine.jpeg';
import kelly from 'assets/mentors/kelly.jpg';
import kyle from 'assets/mentors/kyle.jpg';
import matt from 'assets/mentors/matt.jpg';
import matthew from 'assets/mentors/matthew.jpg';
import maxim from 'assets/mentors/maxim.jpeg';
import michael from 'assets/mentors/michael.jpg';
import michael2 from 'assets/mentors/michael2.jpeg';
import mjumbe from 'assets/mentors/mjumbe.jpg';
import monica from 'assets/mentors/monica.jpg';
import mustafa from 'assets/mentors/mustafa.jpeg';
import nate from 'assets/mentors/nate.png';
import nathan from 'assets/mentors/nathan.png';
import neil from 'assets/mentors/neil.png';
import nick from 'assets/mentors/nick.jpeg';
import nicolas from 'assets/mentors/nicolas.jpeg';
import pablo from 'assets/mentors/pablo.jpeg';
import praveen from 'assets/mentors/praveen.jpg';
import richard from 'assets/mentors/richard.jpg';
import robert from 'assets/mentors/robert.jpeg';
import sachi from 'assets/mentors/sachi.jpg';
import sam from 'assets/mentors/sam.jpg';
import seth from 'assets/mentors/seth.png';
import shaan from 'assets/mentors/shaan.jpeg';
import shahzad from 'assets/mentors/shahzad.jpg';
import shivam from 'assets/mentors/shivam.jpg';
import srujun from 'assets/mentors/srujun.jpg';
import steve from 'assets/mentors/steve.jpg';
import sumant from 'assets/mentors/sumant.jpg';
import thomas from 'assets/mentors/thomas.jpg';
import trenton from 'assets/mentors/trenton.png';
import tyler from 'assets/mentors/tyler.jpg';
import yu from 'assets/mentors/yu.jpeg';
import zach from 'assets/mentors/zach.jpg';
import zeeshan from 'assets/mentors/zeeshan.jpg';

export const tags = ['DATA SCI', 'LANGUAGES', 'SYSTEMS', 'WEB DEV'];

export const mentors = [
  {
    img: monica,
    name: 'Monica Muthaiya',
    bio: 'I graduated from UIUC in May 2019 and work at Optum as a software developer. I have professional experience in UI/UX and web development. In my free time, I enjoy traveling, DJing, hiking/backpacking, and volunteering.',
    tags: ['WEB DEV'],
  },
  {
    img: sachi,
    name: 'Sachi Singh',
    bio: 'I am a software engineer in the Technology Development Program at Optum. I graduated from UIUC Bioengineering with a minor in CS last May.',
    tags: ['WEB DEV'],
  },
  {
    img: kelly,
    name: 'Kelly Shen',
    bio: 'I am a data engineer at NYC startup Button. Previously, I was a data engineer at Etsy where I worked on the e-commerce site\'s in-house A/B testing platform. I have been an avid Julia user and contributor since my undergraduate days at MIT.',
    tags: ['LANGUAGES'],
  },
  {
    img: matt,
    name: 'Matt Sicker',
    bio: 'I\'m a software engineer and a free/open source software evangelist with a bit of a functional programming background. Outside programming, I\'m interested in coffee, cooking, beer, reading, and many other topics.',
    tags: ['WEB DEV'],
  },
  {
    img: andrew,
    name: 'Andrew Lundholm',
    bio: 'I am a software engineer specializing in frontend technologies at OptumRx.',
    tags: ['WEB DEV'],
  },
  {
    img: tyler,
    name: 'Tyler Leonhardt',
    bio: 'I\'m a PowerShell team member at Microsoft. All my work is open source. I\'m also a member of @thelivecoders and @PowerShellLive, both communities of live coding Twitch streamers. I like coffee with the word "mouthfeel" on the package ☕️',
    tags: ['LANGUAGES'],
  },
  {
    img: michael2,
    name: 'Michael Kruse',
    bio: 'I graduated with a Master\'s degree in Computer Science from the University of Paderborn in Germany and a PhD from the University Paris-Sud 11. After a Post-Doc at the École Normale Supérieur, I currently work at Argonne National Laboratory. I contribute to the LLVM compiler infrastructure, including Polly, LLVM\'s polyhedral optimizer.',
    tags: ['LANGUAGES'],
  },
  {
    img: sam,
    name: 'Sam Moore',
    bio: 'I am a full-stack developer with years of experience building mobile, web, and back-end applications for a variety of projects. These days, I typically work in JavaScript due to its versatility, but also have professional experience in Swift, Objective-C, Ruby, PHP, and Kotlin.',
    tags: ['WEB DEV'],
  },
  {
    img: corly,
    name: 'Corly Leung',
    bio: 'I\'m a Software Engineer working on image understanding and AR in Google Lens!',
    tags: ['DATA SCI'],
  },
  {
    img: jonathan2,
    name: 'Jonathan Wexler',
    bio: 'I\'m a recent grad from UIUC from Chicago who\'s working in prop trading in NYC.',
    tags: ['SYSTEMS'],
  },
  {
    img: mjumbe,
    name: 'Mjumbe Poe',
    bio: 'I have been developing civic technology since 2010. I endeavor to use technology to build the capacity of individuals and communities to shape their cities, their neighborhoods, and their own lives. In addition to working as a Data Engineer at Betterment, I am co-founder and CTO of Stepwise, a company dedicated to leveraging open data to help people make smarter, more impactful investments in the built environment.',
    tags: ['WEB DEV'],
  },
  {
    img: katharine,
    name: 'Katharine Hyatt',
    bio: 'I\'m a postdoc at the Center for Computational Quantum Physics at the Flatiron Institute in NYC. I do a lot of Julia programming, especially GPU computing, numerical linear algebra, and work on base Julia itself. Happy to mentor people with interests in Julia\'s GPU, parallel computing, linear algebra, or ML stack.',
    tags: ['LANGUAGES'],
  },
  {
    img: nick,
    name: 'Nick Magerko',
    bio: 'I am a University of Illinois alum and previous HackIllinois organizer! I am currently working on infrastructure at Facebook.',
    tags: ['SYSTEMS'],
  },
  {
    img: maxim,
    name: 'Maxim Belkin',
    bio: 'I am the Education and Training Coordinator with the Blue Waters petascale supercomputer project at the National Center for Supercomputing Applications (NCSA) with a background in physics and scientific computing. I am also a member of Homebrew and a maintainer of the Linuxbrew/homebrew-xorg repository.',
    tags: ['LANGUAGES'],
  },
  {
    img: sumant,
    name: 'Sumant Kowshik',
    bio: 'I got my PhD at UIUC in 2006. I work on Facebook AI for image/video understanding, and personalization.',
    tags: ['SYSTEMS'],
  },
  {
    img: cody,
    name: 'Cody Sherman',
    bio: 'I specialize in clean and modern UI and UX, and am a self declared CSS wizard, tech enthusiast, and video game addict. I have worked for multiple start-ups and run the open source project Frow CSS in my free time.',
    tags: ['WEB DEV'],
  },
  {
    img: brandon,
    name: 'Brandon Frisch',
    bio: 'I\'m a startup founder and tech entrepreneur. I specialize in strategy for early-stage tech products. I\'m also highly proficient in HTML/CSS development.',
    tags: ['WEB DEV'],
  },
  {
    img: johnmark,
    name: 'Johnmark Beaty',
    bio: 'I write code. Lots of it.',
    tags: ['WEB DEV'],
  },
  {
    img: clay,
    name: 'Clay Schumacher',
    bio: 'In 2017 I founded Square Ninety, a software development company which specializes in creating mobile, web and connected TV applications for startups and small businesses. I am an agile enthusiast, and when not writing software and helping dev teams I run a weekly board game night and spend time with my wife and two daughters.',
    tags: ['WEB DEV'],
  },
  {
    img: thomas,
    name: 'Thomas Pocius',
    bio: 'I am a junior full stack developer and licensed physical therapist. I just completed Northwestern University Coding Boot Camp full stack program (MERN). My biggest strengths are communication, critical thinking, and problem solving.',
    tags: ['WEB DEV'],
  },
  {
    img: richard,
    name: 'Richard Kim',
    bio: 'I am a Java and Salesforce guru. In my free time, I like creating websites using Meteor, VueJS and React. I also stream video games professionally.',
    tags: ['WEB DEV'],
  },
  {
    img: nathan,
    name: 'Nathan Handler',
    bio: 'I have been involved with the open source community for over a decade, primarily through roles as an Ubuntu and Debian GNU/Linux Developer and a member of the freenode IRC staff. During the day, I work as a Developer Advocate and Software Engineer at Orchid Labs.',
    tags: ['SYSTEMS'],
  },
  {
    img: abdulrahman,
    name: 'Abdulrahman Mahmoud',
    bio: 'I am a final year graduate student in computer science at UIUC, doing research at the intersection of computer architecture, software testing, and deep learning. When I am not in front of a computer coding, I enjoy soccer, chess, gaming (PC master race!) and watching documentaries (seriously!).',
    tags: ['SYSTEMS'],
  },
  {
    img: christian,
    name: 'Christian Cygnus',
    bio: 'I am a Software Engineer at IMC in Chicago. I\'ve been working there for about 1.5 years now. Before IMC, I went to UIUC for CS. This will be my 5th year attending HackIllinois!',
    tags: ['SYSTEMS'],
  },
  {
    img: david,
    name: 'David Garcia Quintas',
    bio: 'Originally from rainy northern Spain, I\'ve been jumping around for a while: I spent 4 years at CERN (Geneva, Switzerland) 2006-2010. I saw the LHC get started. Twice. Also wrote part of its control software. I moved to the US in 2010 to work at the Lawrence Berkeley National Lab in similar expensive physics toys. I joined Google and joined Waymo in Sep 2019, where I work in the infrastructure team.',
    tags: ['SYSTEMS'],
  },
  {
    img: nicolas,
    name: 'Nicolas Nytko',
    bio: 'I am a CS@UIUC alum and PrairieLearn developer.',
    tags: ['WEB DEV'],
  },
  {
    img: zach,
    name: 'Zach Auten',
    bio: 'I live in North Carolina and I\'m a Homebrew maintainer.',
    tags: ['SYSTEMS'],
  },
  {
    img: nate,
    name: 'Nate Graham',
    bio: 'I grew up in Champaign-Urbana, worked at Apple, and now find myself a software developer and project manager with KDE.',
    tags: ['SYSTEMS'],
  },
  {
    img: dustin,
    name: 'Dustin George',
    bio: 'I am a software engineer for Optum. I graduated from UIUC in Spring 2019 ✌🏾🐼',
    tags: ['WEB DEV'],
  },
  {
    img: ashok,
    name: 'Ashok Arjunakani',
    bio: 'I am a full-stack web developer working at OptumRx. I went to U of I for Bioengineering and CS. I am passionate about healthcare technology and how we can use it to help people live healthier lives!',
    tags: ['WEB DEV'],
  },
  {
    img: joshua,
    name: 'Joshua Dyer',
    bio: 'I\'m a web developer at Mirus Research.',
    tags: ['WEB DEV'],
  },
  {
    img: matthew,
    name: 'Matthew Dierker',
    bio: 'Hi! I work on Gmail and I love talking with people. Come say hi!',
    tags: ['WEB DEV'],
  },
  {
    img: steve,
    name: 'Steve Loucks',
    bio: 'I\'ve been working in the software industry for 15 years developing desktop, mobile, and web applications. My passion is to solve hard problems while collaborating with fun people.',
    tags: ['WEB DEV'],
  },
  {
    img: jon,
    name: 'Jon Spaulding',
    bio: 'I\'m a web developer with Mirus Research.',
    tags: ['WEB DEV'],
  },
  {
    img: john,
    name: 'John Nam',
    bio: 'I work at Caterpillar as a Sr. Data Scientist. Even though I am not a CS major, I work with lots of data sets and can help you!',
    tags: ['DATA SCI'],
  },
  {
    img: kyle,
    name: 'Kyle Cline',
    bio: 'I\'m an analytics manager with Caterpillar\'s IoT Analytics team in Cat Digital! I have a team of data scientists and engineers who work in Research Park here at UIUC and we are always looking for awesome interns! I graduated from UIUC in Electrical Engineering and have worked at Caterpillar for almost 15 years. As a programmer, I cut my teeth on C++. These days, I love all things Python, Arduino, and Raspberry Pi.',
    tags: ['DATA SCI'],
  },
  {
    img: james2,
    name: 'James Mason',
    bio: 'I am a Senior Data Scientist at Caterpillar with a background in artificial intelligence, database design, graphic design, and more programming languages than I care to mention!',
    tags: ['DATA SCI'],
  },
  {
    img: neil,
    name: 'Neil Hinrichsen',
    bio: 'I am an IT Analyst at Caterpillar. Happy to be here for my first time mentoring! I am a financial analyst gone techie. My interests in tech are anything cloudy, AI, Big Data, and building PCs and servers. If it’s tech and you can take it apart there is a good chance I have. Feel free to come up and chat about your craziest Gaming Rigs Setups or Media Servers! Cheers to a good weekend!',
    tags: ['SYSTEMS'],
  },
  {
    img: ann,
    name: 'Ann Peedikayil',
    bio: 'I work at Caterpillar as a Senior Digital Analyst Project Leader. I started as a structural engineer creating simulations of our large mining trucks using machine performance data. Now I work with data that evaluates our dealers digital capabilities. Looking forward to seeing how you all tackle the Caterpillar challenge!',
    tags: ['DATA SCI'],
  },
  {
    img: trenton,
    name: 'Trenton Spice',
    bio: 'I am a full stack software engineer from the Indianapolis area.',
    tags: ['SYSTEMS', 'WEB DEV'],
  },
  {
    img: adar,
    name: 'Adar Bar-Shalom',
    bio: 'I am a programmer at NELiX, Inc., a team of ten developers cranking out code on several projects at once for multiple clients. My background in art, music, sports and gaming has nurtured me to become a competitive player and a worthy opponent. I love meeting new people, and making memories with old friends and new.',
    tags: ['LANGUAGES', 'WEB DEV'],
  },
  {
    img: shivam,
    name: 'Shivam Bharuka',
    bio: 'I am a production engineer, supporting the AI infrastructure at Facebook. My research interests include exploring new computer architectures and designing scalable distributed systems. Before joining Facebook, I graduated with a master’s and a bachelor’s degree from University of Illinois at Urbana-Champaign, studying Computer Engineering.',
    tags: ['DATA SCI', 'SYSTEMS'],
  },
  {
    img: yu,
    name: 'Yu Wang',
    bio: 'I am a product enthusiast. I build ads and consumer facing products at Instagram.',
    tags: ['DATA SCI', 'WEB DEV'],
  },
  {
    img: shahzad,
    name: 'Shahzad Bhatti',
    bio: 'I work at Facebook as a Research Scientist in the AI org. I primarily work on a Language Identification classifier which determines the language of an audio signal if there is human speech in it. I have also developed a VAD classifier which detects human speech in an audio signal.',
    tags: ['SYSTEMS', 'DATA SCI'],
  },
  {
    img: jonathan,
    name: 'Jonathan Reynolds',
    bio: 'I\'m a UIUC \'19 alumnus. I studied Computer Science at U of I, and now I work at Facebook as a software engineer on the PyTorch team. Outside of work, I like working on projects related to computer vision and graphics. I also enjoy running, rock climbing, and gaming in my free time.',
    tags: ['SYSTEMS', 'DATA SCI'],
  },
  {
    img: edward,
    name: 'Edward Xue',
    bio: 'I received my CS undergrad and masters at UIUC. I love to play guitar, sing, and game!',
    tags: ['WEB DEV', 'SYSTEMS'],
  },
  {
    img: michael,
    name: 'Michael Tamillow',
    bio: 'I make complex systems, build software for the future of machine learning, work at a bank, and am living the dream!',
    tags: ['DATA SCI', 'SYSTEMS'],
  },
  {
    img: pablo,
    name: 'Pablo Aguiar',
    bio: 'I\'m a computer scientist from Brazil, where I worked as a software engineer at Globo.com, Latin America\'s largest media and publishing company. Currently, I\'m living in lovely Munich, Germany, creating a disruptive B2B solution for the music industry! I\'ve been writing programs since I was 11, and professionally for at least 20 years. I can mentor on Python, Go, Elixir, Rust, Lua, OpenCV, Fish Shell/Oh My Fish!, Flask, Tornado, Phoenix/LiveView, and related things. I\'m looking forward to having loads of fun at HackIllinois!',
    tags: ['SYSTEMS', 'WEB DEV'],
  },
  {
    img: jeff,
    name: 'Jeff Bezanson',
    bio: 'My first program was \'10 PRINT "HELLO WORLD"\' in BASIC. Since then I\'ve been hooked. I am one of the creators of a programming language called Julia, a fun and powerful language where science, machine learning, data science, and compilers meet, and where you can work with a lot of people with different skills and learn a lot!',
    tags: ['LANGUAGES', 'DATA SCI'],
  },
  {
    img: dave,
    name: 'Dave Mussulman',
    bio: 'I am an Instructional Technology Facilitator with Engineering IT, helping Grainger College of Engineering faculty innovate with technologies in their classes.',
    tags: ['SYSTEMS', 'WEB DEV'],
  },
  {
    img: james,
    name: 'James Sheputis',
    bio: 'I am a Software Engineer with a Master of Science in Computer Science. In my free time I work on home automation.',
    tags: ['LANGUAGES', 'WEB DEV'],
  },
  {
    img: shaan,
    name: 'Shaan Patel',
    bio: 'I am a software engineer at IMC Trading.',
    tags: ['SYSTEMS', 'LANGUAGES'],
  },
  {
    img: erik,
    name: 'Erik Torres',
    bio: 'I am pursuing a career in Software Engineering and Artificial Intelligence. I am experienced in Robotic Process Automation (RPA) development, web development and machine learning with a demonstrated knowledge of software development obtained through my experience and coursework.',
    tags: ['LANGUAGES', 'WEB DEV'],
  },
  {
    img: zeeshan,
    name: 'Zeeshan Haidry',
    bio: 'I graduated from UIUC in May 2018 with a B.S. in Bioengineering. Currently, I focus on backend development for the clinical side of Optum.',
    tags: ['LANGUAGES', 'WEB DEV'],
  },
  {
    img: justin,
    name: 'Justin Yang',
    bio: 'I’m a Software Engineer in Google Ads and an Illinois alumnus (BSEE ’19).',
    tags: ['SYSTEMS', 'LANGUAGES'],
  },
  {
    img: alec,
    name: 'Alec Troemel',
    bio: 'I’m a full stack developer with experience in Javascript, Python, Django, Vue, Docker, Kubernetes, Rust, and a little bit of a bunch more. I’m an emacs devotee who wishes he was a true lisp hacker and had more time to make games in Pico8.',
    tags: ['WEB DEV', 'LANGUAGES'],
  },
  {
    img: gino,
    name: 'Gino Corrales',
    bio: 'I\'m a Cybersecurity Software Engineer with Caterpillar IT HQ! I work for the Identity Access Management team as a Testing Lead of an identity management platform. I am very passionate about open source projects and wearable technologies. Ping me or stop by the Caterpillar booth, I\'ll be so  happy to help with your projects throughout the weekend.',
    tags: ['SYSTEMS', 'WEB DEV'],
  },
  {
    img: jason,
    name: 'Jason Coombs',
    bio: 'I am Site Reliability Manager at Google Pittsburgh, with 20+ years of experience in Python. I am a shared or sole maintainer for over 140 projects in the Python ecosystem, a responsibility which I have accumulated over the past decade of my open source contributions.',
    tags: ['LANGUAGES', 'WEB DEV', 'SYSTEMS'],
  },
  {
    img: robert,
    name: 'Robert Miroballi',
    bio: 'I am a Principal Architect at NVISIA in Chicago. I have many years of software development experience in many different languages.',
    tags: ['LANGUAGES', 'WEB DEV', 'SYSTEMS'],
  },
  {
    img: amber,
    name: 'Amber Sahdev',
    bio: 'I received my Bachelors and Masters in Computer Engineering at UIUC.',
    tags: ['DATA SCI', 'LANGUAGES', 'SYSTEMS', 'WEB DEV'],
  },
  {
    img: mustafa,
    name: 'Mustafa Abdul-Kader',
    bio: 'I am a tech enthusiast, urban dweller, and full-time dad to two cats.',
    tags: ['DATA SCI', 'WEB DEV', 'SYSTEMS'],
  },
  {
    img: praveen,
    name: 'Praveen Kumar Meenakshi Sundaram Gandhi',
    bio: 'I\'m a Cloud Software Engineer from Schlumberger. I have a Master\'s degree from USC.',
    tags: ['DATA SCI', 'SYSTEMS', 'LANGUAGES'],
  },
  {
    img: apoorva,
    name: 'Apoorva Dixit',
    bio: 'I graduated from UIUC in May 2019, and now work in Display Ads at Google! I was an intern at Google in 2018 and would love to talk about life at Google and answer any of your career related questions!',
    tags: ['DATA SCI', 'SYSTEMS', 'LANGUAGES', 'WEB DEV'],
  },
  {
    img: anurag,
    name: 'Anurag Bihani',
    bio: 'I\'m a computer geek and a technology enthusiast. I like to acquire new skills in order to solve meaningful problems. I currently work as a back-end software engineer for Seismic / Subsurface Exploration Oil and Gas projects at the Geophysics Technology Center, Schlumberger.',
    tags: ['DATA SCI', 'SYSTEMS', 'LANGUAGES', 'WEB DEV'],
  },
  {
    img: frank,
    name: 'Frank Trampe',
    bio: 'I\'m based in Missouri and work for clients all over the world, mostly building software, sometimes hardware.',
    tags: ['SYSTEMS', 'LANGUAGES'],
  },
  {
    img: srujun,
    name: 'Srujun Thanmay Gupta',
    bio: 'I am a Software Engineer in Privacy and Data Protection at Google, Chicago. I\'m a UIUC \'18 alumnus who studied Computer Engineering and Business. I am super passionate about large-scale data processing and systems design. Ask me anything about work, advice, or fun!',
    tags: ['LANGUAGES', 'SYSTEMS'],
  },
  {
    img: seth,
    name: 'Seth Bromberger',
    bio: 'I have been involved in network and systems security for over twenty years. My work history spans multiple industries and sectors including government, finance, and energy.',
    tags: ['DATA SCI'],
  },
];
